export function camelCaseToWords(str) {
  return str.replace(/([A-Z])/g, " $1").trim();
}
